import React, { useRef, useEffect, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';
import {FrenchTypes} from '../../../../../../../../constants/utils/connectionTypes';
import ServiceData from '../../../../../../../../constants/models/serviceData';

import {ModalActivitySection} from './activitySection';

export const FormActivity = ({ activities, isLoading, userId, relocationDeclaration, setEditMode }) => {
	const [activityList, setActivityList] = useState([...activities]);
	useEffect(() => {
		setActivityList([...activities]);
	}, [activities]);

	function removeFromList(index) {
		setActivityList(activityList.filter((a) => a !== activityList[index]));
	}
	return (
		<div className="card mx-sm mt-xs rounded">
			<div className="card-body scroll-default py-0">
				{/* <p className="o-60">Modifier les champs qui ne sont pas mis à jour</p> */}

				<article className="card" id="activity">
					<h3 className="sr-only visually-hidden">En activité</h3>

					{activityList.map((activity, index) => {
						return <ModalActivitySection activity={activity} initCollapsedState={false} index={index} isLoading={isLoading} key={index} removeFromList={removeFromList} relocationDeclaration={relocationDeclaration} />;
					})}
					<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center pt-4 pb-1">
						<h4 className="sr-only visually-hidden">Ajouter une autre ACTIVITÉ</h4>
						<button
							type="button"
							className="btn btn-icon btn-alert-info mx-auto py-2"
							onClick={(e) => {
								let serviceData = new ServiceData({
									userId: userId,
									serviceType: FrenchTypes.activity,
									serviceId: "activite" + activityList.length,
									payload: {
										type: "Activite",
										companyName: "",
										companyAddressStreet1: "",
										companyAddressStreet2: "",
										companyAddressPostalCode: "",
										companyAddressLocality: "",
										companyAddressCountry: "FR",
										function: "",
										contractType: "CDD",
										companySavingsPlanReference: "",
									},
								});
								setActivityList([...activityList, { ...serviceData, collapsed: true }]);
							}}>
							<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre ACTIVITÉ
						</button>
					</footer>
				</article>
			</div>
			<div className="card-footer">
				<button
					type="button"
					className="btn btn-light mr-2"
					onClick={(e) => {
						e.preventDefault();
						setActivityList([...activities]);
						setEditMode(false);
					}}>
					Annuler
				</button>
				{/* <button
							type="button"
							className="btn btn-info"
							onClick={(e) => {
								e.preventDefault();
								activityForm.current.classList.add("was-validated");
								setWasValidated(true);
							}}>
							Sauvegarder
						</button> */}
			</div>
		</div>
	);
};